document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".home-reviews-swiper .swiper", {
    slidesPerView: 1.2,
    spaceBetween: 30,
    loop: true,
    centeredSlidesBounds: true,
    breakpoints: { 
      320: {  //当屏幕宽度大于等于320
        spaceBetween: 13
      },
      590: {  //当屏幕宽度大于等于320
        spaceBetween: 13
      },
    },
    navigation: {
      nextEl: '.home-reviews-swiper .swiper-button-next',
      prevEl: '.home-reviews-swiper .swiper-button-prev',
    },
    pagination: {
      el: '.home-reviews-swiper .swiper-pagination',
    },
  });
});
